<h2 mat-dialog-title>{{ card.type.title }}</h2>

<mat-dialog-content>
    @if (form) {
        <form [formGroup]="form.control">
            <div class="form-container">
                <eas-easform-group [easGroup]="form"></eas-easform-group>
            </div>
        </form>
    }
    <eas-interactive-table [options]="tableComponentOptions"></eas-interactive-table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button type="button" color="primary" (click)="onSave()" i18n>Apply</button>
</mat-dialog-actions>
